import {Link} from 'react-router-dom';
// import {useSelector} from 'react-redux';
import {ArrowLeftOutlined} from '@ant-design/icons';

import TabCard from '../../components/ui/TabCard/TabCard';
import {pageTabConfig} from './configs/pageTables/pageTabConfig';

const CurrentDeals = ({
    data,
    das,
    filterDealList,
    tableType,
    userData,
    tableLoading,
    setDasKey,
    paginationMetadata,
    handleGetData,
    dasKey
}) => {
    const tableConfig = {filterDealList, tableType, userData, tableLoading, paginationMetadata, handleGetData, dasKey};
    // const userData = useSelector((state) => state.UserReducer.userProfileData);

    const handleChangeDasKey = (das) => {
        setDasKey(das.label === "Cabinet" ? '' : das.label);
    }

    return (
        <>
            <div className='flex items-center justify-between pt-10 pb-5'>
                <Link to='/dashboard/codev'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Affaires en cours (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>

            <TabCard config={pageTabConfig(data, "deals", das, tableConfig)} onChange={handleChangeDasKey}/>
        </>
    )
}

export default CurrentDeals;
